<section class="contacto-section">
  <div class="contacto-container">
    <h2 class="contacto-title">¿Tenés alguna duda?</h2>
    <p class="contacto-subtitle">Contactanos y te respondemos al toque</p>

    <a
      class="whatsapp-card"
      [href]="whatsappUrl"
      target="_blank"
      rel="noopener noreferrer"
    >
      <i class="fab fa-whatsapp"></i>
      <span>Enviar mensaje</span>
    </a>
  </div>
</section>
